var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [_vm.currentRound.optionalContent ? _c('section', {
    staticClass: "dynamicContentSection"
  }, [_c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.optionalContent
    }
  })], 1) : _vm._e(), _c('section', {
    staticClass: "questionSection"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.questionHtml
    }
  })], 1), _c('section', {
    staticClass: "answerSection"
  }, _vm._l(_vm.currentRound.sentences, function (sentence, index1) {
    return _c('div', {
      key: index1,
      staticClass: "sentence"
    }, _vm._l(sentence.fragments, function (fragment, index2) {
      return _c('fragment', {
        key: index2
      }, [fragment.textHtml ? _c('html-renderer', {
        attrs: {
          "htmlObject": fragment.textHtml,
          "isPickTheAnswer": ""
        }
      }) : _vm._e(), fragment.answers ? _c('dropdown', {
        attrs: {
          "id": 1,
          "sentence-index": index1,
          "dropdown-index": index2,
          "options": fragment.answers,
          "enabled": true,
          "on-item-select": _vm.onDropDownSelect,
          "is-correct": _vm.correctGuesses.length && _vm.correctGuesses[index1][index2] ? true : false,
          "num-of-attempts": _vm.numOfAttempts
        }
      }) : _vm._e()], 1);
    }), 1);
  }), 0), _vm.showActivityNextSectionPortal ? _c('activity-next-section-portal', {
    attrs: {
      "handleOnActivitySubmit": _vm.handleOnActivitySubmit,
      "displayWrongIcon": _vm.displayWrongIcon,
      "displayCorrectIcon": _vm.displayCorrectIcon
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }